import CreateProjectButton from '../../components/create-project-button/CreateProjectButton';
import RoundedButtonSecondary from '../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import Image from '../../components/image/Image';
import styles from './start-spleis-box.module.less';
import { Heading5, SmallText } from '@sb1/ffe-core-react';

const StartSpleisBox = ({ title, image, smallText, description, buttonText, startProjectParameters }) => {
    return (
        <div className={styles.container}>
            <Image className={styles.image} src={image} />
            <div className={styles.textContainer}>
                {smallText && <SmallText className={styles.smallText}>{smallText}</SmallText>}
                <Heading5 noMargin>{title}</Heading5>
                <div>{description}</div>
            </div>
            <div className={styles.buttonWrapper}>
                <CreateProjectButton
                    className={styles.button}
                    linkParams={startProjectParameters}
                    buttonElement={RoundedButtonSecondary}
                >
                    {buttonText}
                </CreateProjectButton>
            </div>
        </div>
    );
};
export default StartSpleisBox;
